var map = {
	"./covid.png": "8104",
	"./financely.png": "dbe3",
	"./hotpot.png": "997b",
	"./illustration.png": "5ac9",
	"./linkedin.png": "c644",
	"./photography.png": "4b5f",
	"./qrpay.png": "a252",
	"./rabbit.png": "1384",
	"./site.png": "7f96",
	"./vibeify.png": "2145",
	"./watchlist.png": "f7ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca6d";